module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0134.jpg?v=35778cb7";